import TeacherRoutes from './routes/teacher'
import AdminRoutes from './routes/admin'
import SuperAdminRoutes from './routes/superAdmin'
import AuthRoutes from './routes/auth'
import dashboardGuard from './guards/dashboardGuard';
import isSuperAdmin from './guards/isSuperAdmin';

/**
 * Every route becomes a chunk, loaded only when used.
 * Reduces size of initial App load.
 */
const routes = [

    {
        path: '/login',
        redirect: 'login',
        component: () => import(/* webpackChunkName: "layouts/AuthLayout" */ '@views/layouts/AuthLayout'),
        children: AuthRoutes
    },

    {
        path: '/teacher-dashboard',
        redirect: 'teacher-dashboard',
        component: () => import(/* webpackChunkName: "layouts/TeacherLayout" */ '@views/layouts/TeacherLayout'),
        meta: {
            requiresAuth: true
        },
        children: TeacherRoutes
    },
    {
        path: '/',
        redirect: 'dashboard',
        component: () => import(/* webpackChunkName: "layouts/MasterLayout" */ '@views/layouts/MasterLayout'),
        meta: {
            requiresAuth: true
        },
        children: AdminRoutes,
        beforeEnter: dashboardGuard
    },
    {
        path: '/super-admin',
        redirect: 'dashboard',
        component: () => import(/* webpackChunkName: "layouts/MasterLayout" */ '@views/layouts/MasterLayout'),
        meta: {
            requiresAuth: true
        },
        children: SuperAdminRoutes,
        beforeEnter: isSuperAdmin
    },
    {
        path: '/updates',
        name: 'updates',
        component: () => import(/* webpackChunkName: "views/UpdatesPage" */ '@views/UpdatesPage'),
    },
    {
        path: '/landing', // New route for the welcome page
        component: () => import(/* webpackChunkName: "views/Landing" */ '@views/Landing'), // Component to render
        name: 'landing', // Optional: name the route
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import(/* webpackChunkName: "views/NotFound" */ '../NotFound.vue')
    },
    {
        path: '/403',
        name: 'forbidden',
        component: () => import(/* webpackChunkName: "views/Forbidden" */ '../Forbidden.vue')
    },
];

export default routes